import React from 'react'
import Layout from '../../Layout'
import NewPayRequestContainer from '../../../../Components/PayRequest/NewPayRequestContainer/NewPayRequestContainer'

const newPayRequest = () => {
  return (
    <Layout><NewPayRequestContainer/></Layout>
  )
}

export default newPayRequest